export const WEBSHOP_MIN_PRODUCT_QUANTITY = 1;
export const WEBSHOP_MAX_PRODUCT_QUANTITY = 99;
export const WEBSHOP_PRODUCT_PER_PAGE = 5;
export const WEBSHOP_MIN_STOCK_ORDER_QUANTITY = 0;
export const WEBSHOP_MAX_STOCK_ORDER_QUANTITY = 99;
export const WEBSHOP_DROPDOWN_LINE_HEIGHT = 1.5;

// Product category keys (PascalCase as returned by MLS API)
export const PRODUCT_CATEGORY_COLOR_LENSES = 'ColorLenses';
export const PRODUCT_CATEGORY_DISPOSABLES = 'Disposables';
export const PRODUCT_CATEGORY_LENS_CARE = 'LensCareProducts';
export const PRODUCT_CATEGORY_MTO = 'MadeToOrderLenses';
export const STOCK_ORDER_TYPE = 'stock-order';

// Product category slugs (kebab-case as used in URLs and cart grouping)
export const PRODUCT_CATEGORY_SLUG_LENS_CARE = 'lens-care-products';
export const PRODUCT_CATEGORY_SLUG_DISPOSABLES = 'disposables';
export const PRODUCT_CATEGORY_SLUG_COLOR_LENSES = 'color-lenses';
export const PRODUCT_CATEGORY_SLUG_MTO = 'made-to-order-lenses';

// Preferred display order for categories (new categories will appear at the end)
export const CATEGORY_DISPLAY_ORDER = [
  PRODUCT_CATEGORY_COLOR_LENSES,
  PRODUCT_CATEGORY_DISPOSABLES,
  STOCK_ORDER_TYPE,
  PRODUCT_CATEGORY_LENS_CARE,
  PRODUCT_CATEGORY_MTO
] as const;

/**
 * Convert PascalCase category key to display name.
 * e.g., "MadeToOrderLenses" -> "Made To Order Lenses"
 */
export const pascalCaseToDisplayName = (category: string): string =>
  category.replace(/([A-Z])/g, ' $1').trim();

/**
 * Convert PascalCase category key to URL-encoded text for placeholder images.
 * e.g., "MadeToOrderLenses" -> "Made+To+Order+Lenses"
 * @param category - The category key in PascalCase
 * @param maxLength - Maximum length of the output (default: 25)
 */
export const pascalCaseToUrlText = (category: string, maxLength = 25): string => {
  const text = category.replace(/([A-Z])/g, '+$1').replace(/^\+/, '');
  return text.length > maxLength ? text.substring(0, maxLength) : text;
};

/**
 * Known fallback image text mappings for product categories.
 * Used for placeholder images when product images are unavailable.
 */
export const CATEGORY_FALLBACK_IMAGE_TEXT: Record<string, string> = {
  [PRODUCT_CATEGORY_COLOR_LENSES]: 'Color+Lens',
  [PRODUCT_CATEGORY_DISPOSABLES]: 'Lens',
  [STOCK_ORDER_TYPE]: 'Stock',
  [PRODUCT_CATEGORY_LENS_CARE]: 'Lens+Care',
  [PRODUCT_CATEGORY_MTO]: 'MTO+Lens'
};

/**
 * Get fallback image text for a category.
 * Returns a known mapping if available, otherwise converts PascalCase to URL text.
 */
export const getCategoryFallbackImageText = (category: string): string =>
  CATEGORY_FALLBACK_IMAGE_TEXT[category] || pascalCaseToUrlText(category);
export const ORDERHISTORY_MAX_SEARCH_TERM = 30;
const today = new Date();
const twoYearsAgo = new Date();
twoYearsAgo.setFullYear(today.getFullYear() - 2);
export const ORDERHISTORY_SEARCH_MAX_DATE = today.toISOString();
export const ORDERHISTORY_SEARCH_MIN_DATE = twoYearsAgo.toISOString();

/**
 * @deprecated Lens properties should now preserve the order from the MLS API response
 * The MLS API provides lensProperties in the correct display order
 *
 * This constant is kept for backward compatibility but is no longer used
 * for sorting. Properties are now displayed in the order received from the API.
 */
export const LENS_PROPERTY_PRIORITY_ORDER = [
  'Radius',
  'Diameter',
  'Power',
  'Cylinder',
  'Axis',
  'FrontCylinder',
  'FrontCylinderAxis',
  'Addition'
] as const;
export const HIGHLIGHT_BG_COLORS = ['origami-deep-pink', 'origami-deep-yellow', 'origami-deep-green', 'origami-deep-purple', 'origami-deep-orange'] as const;
export const STOCK_ORDER_CATEGORY_LABELS_BY_SLUG: Record<string, string> = {
  disposables: 'platform.webshop.stock-order-disposables',
  'color-lenses': 'platform.webshop.stock-order-color-lenses'
};
